/* eslint-disable react/no-unknown-property */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import React, {useState, useEffect, useCallback, useRef} from 'react';
import classnames from 'classnames/bind';
import _ from 'lodash';
import {
  DirectionsRenderer,
  DirectionsService,
  GoogleMap,
  Marker,
  MarkerClusterer,
  OverlayView,
} from '@react-google-maps/api';
import {
  ICoordinate,
  ICountry,
  ILocation,
  ISize,
  IState,
  ITWorkshop,
  Replacement,
  IModal,
} from '../../interface';
import Modal from '../../../src/components/Modal';
import {ZOOM} from '../../config/mapConfig';
import style from './index.module.scss';
import publicImage from '../../utils/publicImage';
import moment from 'moment';
import analyseData from '../../utils/analyseData';
import localesReplacement from '../../utils/localesReplacement';
import {connect} from 'react-redux';
import {Dispatch} from 'redux';
import actions from '../../redux/actions';
import {usePosition} from '../../hooks/use-position';
import {
  ANALYTICS_EVENT,
  ANALYTICS_PAGE_TYPE,
  ANALYTICS_SERVICE_TYPE,
  CountriesWithCustomizedWTB,
} from "../../constants";
import {checkHttpAddress} from '../../utils/validate';
import {getLocationImage} from '../../utils';
import { useAnalytics } from "../../hooks/use-analytics";

import Zoom from '../NewUI/Zoom';

const cx = classnames.bind(style);

export interface IProps {
  address: ILocation | undefined;
  size: ISize;
  workshops: ITWorkshop[] | undefined;
  replacements: Replacement;
  setAddress: (value: ILocation | undefined) => void;
  resetMarket?: boolean;
  selectedLocation: ITWorkshop | null;
  setSelectedLocation: (value: ITWorkshop | null) => void;
  onContactClick: (value: ITWorkshop) => void;
  country: ICountry;
  onAccordOpen: () => void;
  accord: boolean;
  setModal: (value: IModal) => void;
  enableWtbDistanceFilter: boolean;
  workshopsForMap: ITWorkshop[];
  noPosition?: boolean;
}

/* eslint-disable */
export const GoogleMapContainer = (props: IProps) => {
  const {
    address,
    size,
    workshops,
    replacements,
    setAddress,
    resetMarket,
    selectedLocation,
    setSelectedLocation,
    country,
    onAccordOpen,
    accord,
    setModal,
    enableWtbDistanceFilter,
    workshopsForMap,
    noPosition,
  } = props;


  const sendAnalytics = useAnalytics();
  const [myPosition] = usePosition(country.name, replacements);
  const [directions, setDirections] = useState<google.maps.DirectionsResult>();
  const [infoBoxExpend, setInfoBoxExpend] = useState<boolean>(false);
  const [time, setTime] = useState<string | undefined>();
  const [center, setCenter] = useState<ICoordinate>();
  const [location, setLocation] = useState<ICoordinate>();
  const [showDirection, setShowDirection] = useState<boolean>(false);
  const [expand, setExpand] = useState<boolean>(true);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [isIPhone, setIsIPhone] = useState<boolean>(false);
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [workshopsToConsider, setWorkshopsToConsider] =
    useState<ITWorkshop[]>();

  const getIcon = (workshop: ITWorkshop) => {
    if (workshop.castrolCertified) {
      return 'icon-service.svg';
    } else {
      return 'Castrol_logo_round_icon.png';
    }
  };

  const onSelectMarker = (value: ITWorkshop) => {
    setSelectedLocation(value);
    setCenter({lat: value.address.latitude, lng: value.address.longitude});
  };

  useEffect(() => {
    if (!enableWtbDistanceFilter) {
      setWorkshopsToConsider(workshopsForMap);
    } else {
      setWorkshopsToConsider(workshops);
    }
  });

  useEffect(() => {
    setSelectedLocation(selectedLocation);
    selectedLocation &&
      setCenter({
        lat: selectedLocation.address.latitude,
        lng: selectedLocation.address.longitude,
      });
    setShowDirection(false);
    setExpand(true);
  }, [selectedLocation]);

  let count = React.useRef(0);
  const directionsCallback = useCallback(
    (
      result: google.maps.DirectionsResult | null,
      status: google.maps.DirectionsStatus,
    ) => {
      if (result !== null) {
        if (status === 'OK' && count.current < 2) {
          count.current += 1;
          result.routes[0].legs[0].duration &&
            setTime(result.routes[0].legs[0].duration.text);
          setDirections(result);
        } else {
          count.current = 0;
        }
      }
    },
    [],
  );

  useEffect(() => {
    if (selectedLocation && location) {
      const rotate = google.maps.geometry.spherical.computeHeading(
        new google.maps.LatLng(location.lat, location.lng),
        new google.maps.LatLng(
          selectedLocation?.address.latitude,
          selectedLocation?.address.longitude,
        ),
      );
      if (document.querySelector('img[src$="navigation.svg"]')) {
        (
          document.querySelector('img[src$="navigation.svg"]') as HTMLElement
        ).style.transform = `rotate(${rotate - 45}deg)`;
      }
    }
  }, [selectedLocation, location]);

  useEffect(() => {
    if (address) {
      setLocation(address.coordinate);
      setCenter(address.coordinate);
    } else {
      setLocation(myPosition);
      setCenter(myPosition);
    }
    setSelectedLocation(null);
  }, [address, myPosition]);

  useEffect(() => {
    !_.filter(workshopsToConsider, (d) => _.isEqual(d.id, selectedLocation?.id))
      .length && setSelectedLocation(null);
    getDeviceType();
  }, [workshopsToConsider, selectedLocation?.id]);

  const ref = useRef<google.maps.Map>();
  const setZoomIn = () => {
    const zoom = ref.current?.getZoom();
    ref.current?.setZoom(_.toNumber(zoom) + 1);
  };

  const setZoomOut = () => {
    const zoom = ref.current?.getZoom();
    ref.current?.setZoom(_.toNumber(zoom) - 1);
  };

  const backPosition = () => {
    setLocation(myPosition);
    setCenter(myPosition);
    setAddress(undefined);
  };
  const window: any = globalThis;
  const directionDataLayer = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'whereToBuyDirectionClick',
      pageType: 'where to buy',
      serviceType: selectedLocation?.locationTypes[0].name.toLowerCase(),
      countryCode: localStorage.getItem('countryCode'),
      serviceOutlet: selectedLocation?.name.toLocaleLowerCase(),
    });
  };

  const getDeviceType = () => {
    const ua = navigator.userAgent.toLowerCase();

    if (ua.match(/(iP(hone|od))/i)) {
      setIsIPhone(true);
    }
    if (ua.match(/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i)) {
      setIsMobile(true);
    } else if (
      ua.match(
        /mobile|android|ip(hone|od)|iemobile|blackberry|kindle|silk-accelerated|(hpw|web)os|opera m(obi|ini)/i,
      )
    ) {
      setIsMobile(true);
    }
  };

  const openGMapApp = () => {
    onAccordOpen();
    setShowDirection(true);
    directionDataLayer();
    setExpand(true);
    if (!isIPhone) {
      const protocol = 'http://';
      window.open(
        protocol +
          'maps.google.com?daddr=' +
          selectedLocation?.address?.latitude +
          ',' +
          selectedLocation?.address?.longitude +
          '&amp;ll=',
      );
    } else setModal({visibie: true, href: 0});
  };

  const openMaps = (mapType: any) => {
    if (isMobile) {
      const protocol = 'http://';
      if (mapType === 'ios' && isIPhone)
        window.location =
          protocol +
          'maps.apple.com/maps?daddr=' +
          selectedLocation?.address?.latitude +
          ',' +
          selectedLocation?.address?.longitude +
          '&amp;ll=';
      else
        window.open(
          protocol +
            'maps.google.com?daddr=' +
            selectedLocation?.address?.latitude +
            ',' +
            selectedLocation?.address?.longitude +
            '&amp;ll=',
        );
    }
  };

  const bmgDataLayer = () => {
    sendAnalytics({
      event: ANALYTICS_EVENT.WHERE_TO_BUY_URL_CLICK,
      page: ANALYTICS_PAGE_TYPE.WHERE_TO_BUY,
      serviceType: ANALYTICS_SERVICE_TYPE.BOOK_MY_GARAGE,
      country: localStorage.getItem("countryCode") || "",
      serviceOutlet: selectedLocation.name.toLocaleLowerCase(),
    });
  };  

  const handleBookNow = (url: string) => {
    bmgDataLayer();
    // TODO : possible place to trigger validation dialog box
    window.open(checkHttpAddress(url) ? url : "https://" + url);    
  };

  useEffect(() => {
    setSelectedLocation(null);
  }, [resetMarket]);

  const openLink = () => {
    const link = checkHttpAddress(selectedLocation['website'])
      ? selectedLocation['website']
      : 'https://' + selectedLocation['website'];
    const element = document.querySelector('#external-link-popover');
    if (element) {
      element.dataset.link = link;
    }
  }

  return (
    <>
      {location && workshopsToConsider ? (
        <GoogleMap
          mapContainerStyle={size}
          center={center}
          zoom={ZOOM}
          options={{
            mapTypeControl: false,
            fullscreenControl: false,
            streetViewControl: false,
            zoomControl: false,
            maxZoom: 19,
          }}
          onLoad={(map) => {
            ref.current = map;
          }}
        >
          {/* Child components, such as markers, info windows, etc. */}
          <>
            <>
              <MarkerClusterer>
                {(clusterer) => (
                  <>
                    {_.reject(workshopsToConsider, (d) => {
                      return (
                        (_.isEqual(d.id, selectedLocation?.id) &&
                          !d.address.latitude) ||
                        !d.address.longitude
                      );
                    }).map((location) => (
                      <Marker
                        key={location.id}
                        icon={{
                          url: publicImage(getIcon(location)),
                          origin: new google.maps.Point(0, 0),
                          anchor: new google.maps.Point(10, 10),
                        }}
                        position={{
                          lat: location.address.latitude,
                          lng: location.address.longitude,
                        }}
                        clusterer={clusterer}
                        onClick={() => onSelectMarker(location)}
                      />
                    ))}
                  </>
                )}
              </MarkerClusterer>
              <Marker
                icon={{
                  url: publicImage('navigation.svg'),
                  origin: new google.maps.Point(0, 0),
                  anchor: new google.maps.Point(10, 10),
                }}
                position={location}
                draggable={true}
                onDragEnd={(map) => {
                  if (map.latLng?.lat() && map.latLng?.lng()) {
                    setLocation({
                      lat: map.latLng?.lat(),
                      lng: map.latLng?.lng(),
                    });
                    setCenter({
                      lat: map.latLng?.lat(),
                      lng: map.latLng?.lng(),
                    });
                    setSelectedLocation(null);
                    //Get address
                    const geocoder = new google.maps.Geocoder();
                    geocoder.geocode(
                      {
                        location: {
                          lat: map.latLng?.lat(),
                          lng: map.latLng?.lng(),
                        },
                      },
                      function (results, status) {
                        if (status === google.maps.GeocoderStatus.OK) {
                          if (results) {
                            setAddress({
                              name: results[0].formatted_address,
                              coordinate: {
                                lat: map.latLng?.lat() as number,
                                lng: map.latLng?.lng() as number,
                              },
                            });
                          }
                        }
                      },
                    );
                  }
                }}
              ></Marker>
            </>
            {/* Markers */}

            {/* Infor box for selected marker */}
            {!!selectedLocation && (
              <>
                {/** Markers for google map */}
                <OverlayView
                  mapPaneName={OverlayView.OVERLAY_LAYER}
                  position={{
                    lat: selectedLocation.address.latitude,
                    lng: selectedLocation.address.longitude,
                  }}
                >
                  <div className={cx('overlayview')}>
                    {localesReplacement(replacements, 'Arrival')}: ({time})
                    <img src={publicImage(getIcon(selectedLocation))} />
                  </div>
                </OverlayView>
                {/** Current location marker */}
                <Marker
                  icon={{
                    url: publicImage('point.svg'),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(15, 15),
                  }}
                  position={{
                    lat: selectedLocation.address.latitude,
                    lng: selectedLocation.address.longitude,
                  }}
                ></Marker>
                {/** Inforbox for selected workshop */}
                <div
                  className={`google-inforbox ${cx('inforBox', {
                    expended: infoBoxExpend,
                  })}`}
                >
                  <div className={cx('inner')}>
                    <span
                      className={`button ${cx('toggle-button')} ${cx(
                        expand ? 'collaspe' : '',
                      )}`}
                      role='button'
                      onClick={() => setExpand(!expand)}
                    ></span>
                    <div
                      className={cx('content')}
                      onClick={() => setInfoBoxExpend(true)}
                    >
                      <div className={cx('thumb')}>
                        <Zoom
                          image={getLocationImage(selectedLocation)}
                          alt={selectedLocation['name']}
                          description={selectedLocation['name']}
                        />
                      </div>
                      <div className={cx('details')}>
                        <h6>{selectedLocation['name']}</h6>
                        <div className={cx('accord-icon')}>
                          <button
                            className={cx('primary-button', 'expand', {
                              on: !expand,
                            })}
                            onClick={() => setExpand(true)}
                          >
                            Expand
                          </button>
                          <button
                            className={cx('primary-button', 'collapse', {
                              on: expand,
                            })}
                            onClick={() => setExpand(false)}
                          >
                            Collapse
                          </button>
                        </div>
                      </div>
                    </div>
                    <div
                      className={cx('block-accord', {
                        on: expand,
                        'map-on': !accord,
                      })}
                    >
                      <ul className={cx('inforbox')}>
                        <li className={cx('address')}>
                          <address>
                            {selectedLocation['address']['line1'].split(',').map((item: string, i: number) => item.endsWith(' ') || i === 0 ? item : ` ${item}`).join(',')}
                            {selectedLocation['address']['line2']}
                          </address>
                        </li>
                        {selectedLocation['telephone'] && (
                          <li className={cx('phone')}>
                            {selectedLocation['telephone']}
                          </li>
                        )}
                        {selectedLocation['email'] && (
                          <li className={cx('email')}>
                            {selectedLocation['email']}
                          </li>
                        )}
                        {!_.isEmpty(
                          _.flatMap(
                            selectedLocation['openingHours'],
                            (item) => {
                              return _.compact(
                                _.values(_.pick(item, 'open', 'close')),
                              );
                            },
                          ),
                        ) && (
                          <li className={cx('time')}>
                            <div className={cx('list')}>
                              {_.map(
                                _.sortBy(
                                  selectedLocation['openingHours'],
                                  'isoWeekday',
                                ),
                                (item, index) =>
                                  !!item['open'] && !!item['close'] ? (
                                    <div key={index} className={cx('item')}>
                                      <span>
                                        {localesReplacement(
                                          replacements,
                                          moment.weekdaysShort(
                                            item['isoWeekday'],
                                          ),
                                        )}
                                        :
                                      </span>
                                      {localesReplacement(
                                        replacements,
                                        'Opens from',
                                      )}{' '}
                                      {item['open']
                                        ? analyseData.hourFormat(item['open'])
                                        : ''}{' '}
                                      -{' '}
                                      {item['close']
                                        ? analyseData.hourFormat(item['close'])
                                        : ''}
                                    </div>
                                  ) : null,
                              )}
                            </div>
                          </li>
                        )}
                        {selectedLocation['website'] && (
                          <li className={cx('website')}>                            
                            <button
                              popovertarget="external-link-popover"
                              popoveraction="show"                              
                              target='_blank'
                              rel='noreferrer'
                              onClick={openLink}
                            >
                              {selectedLocation['website']}
                            </button>
                          </li>
                        )}
                      </ul>
                      {/* 3746334 */}
                      {!CountriesWithCustomizedWTB.includes(
                        localStorage.countryCode,
                      ) && (
                        <dl>
                          <dt>
                            {localesReplacement(replacements, 'Location type')}:{' '}
                          </dt>
                          <dd className='overflowText'>
                            {localesReplacement(
                              replacements,
                              _.join(
                                _.map(
                                  selectedLocation['locationTypes'],
                                  'name',
                                ),
                              ),
                            )}
                          </dd>
                        </dl>
                      )}

                      {!_.isEmpty(selectedLocation.images) && selectedLocation.images.length > 1 && (
                        <div className={cx('pictures')}>
                          <h6>
                            {localesReplacement(replacements, 'Pictures')}
                          </h6>
                          <ul>
                            {_.map(
                              selectedLocation.images,
                              (picture, index) => (
                                <li key={index}>
                                  <div className={cx('picture')}>
                                    <Zoom
                                      image={picture}
                                    />
                                  </div>
                                </li>
                              ),
                            )}
                          </ul>
                        </div>
                      )}
                      {
                        <div className={cx('map-icon')}>
                          <button
                            className={cx('map-pin')}
                            onClick={() => {
                              openGMapApp();
                            }}
                          >
                            <span>
                              {localesReplacement(replacements, 'Navigate')}
                            </span>
                          </button>
                        </div>
                      }
                      { selectedLocation.bmgWebsite && (
                        <div className={cx('button-container')}>
                          <button   
                            className={cx("book-now-button")}
                            onClick={() => {
                              handleBookNow(selectedLocation.bmgWebsite);
                            }}
                          >
                            <span>
                              {localesReplacement(replacements, 'Book Now')}
                            </span>                            
                          </button>
                          <strong> {localesReplacement(replacements, "Redirects to external site")} </strong>                            
                        </div>)}                 

                      {isMobile && isIPhone && (
                        <Modal
                          className='abs-map-modal'
                          dismiss={() => setModalVisible(false)}
                        >
                          <div className='modal-map-content'>
                            <button
                              className='primary-button map-popup-close'
                              onClick={() => {
                                setModalVisible(false);
                                setModal({visibie: false, href: 0});
                              }}
                            >
                              Close
                            </button>

                            <div className='map-icon-container'>
                              <img
                                width='100'
                                className='map-img'
                                src={publicImage('gmaps.png')}
                                alt='Google Maps'
                                onClick={() => openMaps('android')}
                              />

                              <img
                                width='100'
                                src={publicImage('ios-map-icon.png')}
                                alt='Apple Maps'
                                onClick={() => openMaps('ios')}
                              />
                            </div>
                          </div>
                        </Modal>
                      )}
                    </div>
                  </div>
                </div>
                {/* <button
                  className={`${cx("open-map-button", {
                    expended: infoBoxExpend,
                  })}`}
                >
                  {localesReplacement(replacements, "Open Google Maps")}
                </button> */}
              </>
            )}
            {/** Google map route line by current location and selected workshop */}
            {!!selectedLocation && (
              <>
                <DirectionsService
                  options={{
                    destination: {
                      lat: selectedLocation.address.latitude,
                      lng: selectedLocation.address.longitude,
                    },
                    origin: location,
                    travelMode: google.maps.TravelMode.DRIVING,
                    unitSystem: google.maps.UnitSystem.IMPERIAL,
                  }}
                  callback={directionsCallback}
                ></DirectionsService>
                {directions && (
                  <DirectionsRenderer
                    // required
                    options={{
                      directions: directions,
                      suppressMarkers: true,
                      polylineOptions: {
                        strokeColor: '#009343',
                      },
                      panel: document.querySelector('#panel') as HTMLElement,
                    }}
                  />
                )}
              </>
            )}
            {/** Custom zoom control */}
            <div className={cx('zooms')}>
              <i className={cx('zoom-in')} onClick={() => setZoomIn()}></i>
              <i className={cx('zoom-out')} onClick={() => setZoomOut()}></i>
            </div>
            {!noPosition && (
              <div className={cx('position')}>
                <i
                  className={cx('get-position')}
                  onClick={() => backPosition()}
                ></i>
              </div>
            )}
          </>
        </GoogleMap>
      ) : (
        <></>
      )}
    </>
  );
};

const mapStateToProps = (state: IState) => ({
  selectedLocation: state.selectedLocation,
  workshops: state.workshops,
  replacements: state.replacements,
  address: state.filter.address,
  country: state.country,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setAddress: (value: ILocation | undefined) =>
    dispatch(actions.setAddress(value)),
  setSelectedLocation: (value: ITWorkshop | null) =>
    dispatch(actions.setSelectedLocation(value)),
  setModal: (value: IModal) => dispatch(actions.setModal(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GoogleMapContainer);
